<div [hidden]="show !== 1">
    <div class="container">
        <div class="col-md-12 lease_table">
            <div>
                <div class="d-flex list justify-content-between align-items-center">

                    <div class="migration_detials">Counselling Report</div>

                    <div class="migration_detials1" (click)="openfilterdialog()" style="cursor: pointer;">
                        Filter <span> <img src="../../../../../assets/image/Filter.svg.svg" alt="filter"
                                class="cctv_filter"></span>
                    </div>

                </div>
                <div class="col-md-12">
                    <section class="section_one" *ngIf="rowData?.length === 0">
                        <div class="cctvcouncelling__sec">
                            <div class="councellist__flex">
                                <div>
                                    <div class="nodata_center">
                                        <figure class="mb-0">
                                            <img src="../../assets/image/nodata.png " alt="nodata" class="nodata">
                                        </figure>
                                        <p class="no_data">No Data Found</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section *ngIf="rowData && rowData.length > 0">
                        <div class="table_data">

                            <!-- Toolbar -->
                            <div class="d-flex align-items-center mb-2">

                                <!-- Download Button (LEFT) -->
                                <button class="btn btn-success" (click)="onBtExport()">
                                    Download Excel
                                </button>

                                <!-- Search (RIGHT END) -->
                                <input type="text" class="form-control ms-auto" style="width: 300px"
                                    placeholder="Search..." [(ngModel)]="quickFilter"
                                    (input)="onQuickFilterChanged()" />

                            </div>

                            <!-- AG Grid -->
                            <ag-grid-angular class="ag-theme-alpine" style="width:100%; height: calc(100vh - 240px);"
                                [rowData]="rowData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"
                                [pagination]="true" [paginationPageSize]="10"
                                [paginationPageSizeSelector]="[10,20,50,100]">
                            </ag-grid-angular>

                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>


<div [hidden]="show !== 2">
    <div>
        <app-student-counselling-details-excelpage (counseback)="counselling($event)"
            [id]="reports"></app-student-counselling-details-excelpage>
    </div>
</div>


<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>